import { render } from "./clientDialog.vue?vue&type=template&id=ee5bbdba&scoped=true"
import script from "./clientDialog.vue?vue&type=script&lang=js"
export * from "./clientDialog.vue?vue&type=script&lang=js"

import "./clientDialog.vue?vue&type=style&index=0&id=ee5bbdba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee5bbdba"]])

export default __exports__